import { create } from "zustand";
import WorkTimeService  from "../../api/admin/workTimeService";
import { convertWorkScheduleToLocal } from "../../helpers/dateHelper";
import { WorkScheduleModel, WorktimeResult } from "../../models/worktimeResult";

interface WorkTimeStore {
  workTime: WorktimeResult | undefined;
  fetchWorkTime: () => Promise<void>;
  updateHours: (newHours: number) => void;
  updateMinutes: (newMinutes: number) => void;
  updateSchedule: (newWorkSchedule: WorkScheduleModel[]) => void;
}

export const useWorkTimeStore = create<WorkTimeStore>((set) => ({
  workTime: undefined,
  fetchWorkTime: async () => {
    const workTimeService = new WorkTimeService();
    try {
      const workTimeUtc = await workTimeService.getWorkTimes();

      const workTime = {
        hours: workTimeUtc.hours,
        minutes: workTimeUtc.minutes,
        schedule: convertWorkScheduleToLocal(workTimeUtc.schedule)
      }

      set({ workTime });
    } catch (error) {}
  },
  updateHours: (newHours: number) => {
    set((state) => ({
      workTime: state.workTime
        ? { ...state.workTime, hours: newHours }
        : undefined,
    }));
  },
  updateMinutes: (newMinutes: number) => {
    set((state) => ({
      workTime: state.workTime
        ? { ...state.workTime, minutes: newMinutes }
        : undefined,
    }));
  },
  updateSchedule: (newWorkSchedule: WorkScheduleModel[]) => {
    set((state) => ({
      workTime: state.workTime
        ? { ...state.workTime, schedule: newWorkSchedule }
        : undefined,
    }));
  },
}));
